import { teaneckConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function TeaneckPage() {
  return <CityPageTemplate config={teaneckConfig} />;
}